import API from './API';
import { GET, POST, PUT } from '../utils/Executer';
import { LABEL_SERVICE_URL as servicePath } from '../constants/APIconstants';

class LabelsServiceAPI {
  async getLabels() {
    return await API.client.execute(GET, servicePath);
  }

  async createLabel({ name, code, color }) {
    return await API.client.execute(POST, servicePath, { name, code, color });
  }

  async updateLabel({ code, name, color }) {
    return await API.client.execute(PUT, `${servicePath}${code}`, { name, code, color });
  }
}

export default new LabelsServiceAPI();
